module.exports = __webpack_public_path__ + "static/media/rooms10.c84438d4.jpg";